<template>
  <div class="summary--step">
    <vue-headful title="Review Appointment Request" />

    <v-layout row wrap>
      <v-flex xs12>
        <StepTitle>Review Appointment Request</StepTitle>
      </v-flex>
    </v-layout>

    <BaseAlert
      v-if="bookingErrors.apiError"
      :hg-value="true"
      hg-type="error"
      ref="alert-api-error">
      There was an error while scheduling your appointment.
      Please check your appointment inputs and try again.
    </BaseAlert>

    <BaseAlert
      v-if="bookingErrors.timeUnavailable"
      :hg-value="true"
      hg-type="error"
      ref="alert-time-unavailable-error">
      The time you requested is no longer available.
      Please <router-link :to="scheduleRouterLink">select another date or time</router-link>
      and try again.
    </BaseAlert>

    <ReviewAppointment />
  </div>
</template>

<script>
import { Components } from '@spectorasoftware/homegauge-vue';
import { mapState } from 'vuex';

import StepTitle from '@/components/StepTitle.vue';
import ReviewAppointment from '@/views/ReviewAppointment.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

const { BaseAlert } = Components;

export default {
  components: {
    BaseAlert,
    ReviewAppointment,
    StepTitle,
  },
  computed: {
    ...mapState('Appointment', ['bookingErrors']),
    scheduleRouterLink() {
      return { name: RouteNameConstants.AppointmentSchedule };
    },
  },
  mounted() {
    this.$store.commit('Appointment/setReachedSummary', true);
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentSummary));
  },
  beforeDestroy() {
    this.$store.commit('Appointment/setTimeUnavailable', false);
    this.$store.commit('Appointment/setApiError', false);
  },
};
</script>
